import { type Theme } from '../../../../theme';
import { type ButtonSize, type ButtonType } from './button.types';

export const getStylesBySize = ({
  size,
  type,
  theme,
  isLoading,
}: {
  size: ButtonSize;
  type: ButtonType;
  theme: Theme;
  isLoading: boolean;
}): { padding: string; minHeight: number } =>
  ({
    regular: {
      padding: theme.spacing(0, 3),
      minHeight: 40,
      ...(['primary', 'upgrade', 'destructive'].includes(type) && {
        minWidth: 100,
      }),
    },
    small: {
      padding: theme.spacing(1, 2),
      minHeight: 32,
    },
    xsmall: {
      padding: isLoading
        ? `1px ${theme.spacing(3)}`
        : `1px ${theme.spacing(2)}`,
      minHeight: 24,
    },
  })[size];

export const getIconMarginBySize = (size: ButtonSize): string =>
  ({
    regular: '8px',
    small: '4px',
    xsmall: '2px',
  })[size];

export const getIconSize = (size: ButtonSize): number =>
  ({
    regular: 20,
    small: 16,
    xsmall: 16,
  })[size];
